import {Button, Stack, Typography} from "@mui/material";
import {ErrorOutline} from "@mui/icons-material";


type ErrorComponentProps = {
    message?: string,
    onRetry?: () => void,
}

const ErrorComponent = (props: ErrorComponentProps) => {
    return <Stack gap={2} justifyContent={"center"} alignItems={"center"}>
        <ErrorOutline fontSize={"large"} sx={{fontSize:"xxx-large"}} />

        <Typography variant={"h5"}>
            {props.message}
        </Typography>

        <Button variant={"contained"} onClick={props.onRetry}>
            Retry
        </Button>
    </Stack>
}

export default ErrorComponent